import ConcurrentModal from './ConcurrentModal';

export default ConcurrentModal;
